import React, { useState } from 'react';
import { MessageSquare, Info } from 'lucide-react';
import { toast } from 'sonner';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';
import { ChatModal } from './ChatModal';

export const MultiLLMChatbot = ({ isAuthenticated, isAdmin, onLoginRequired }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    if (!isAuthenticated) {
      if (onLoginRequired) {
        onLoginRequired();
      }
      toast.info('Please login to use Multi-LLM ChatBot');
      return;
    }
    if (!isAdmin) {
      toast.error('Multi-LLM ChatBot is only available for admin users');
      return;
    }
    toast.success('Opening Multi-LLM ChatBot...');
    setIsOpen(true);
  };

  return (
    <>
      {/* Trigger Button with Tooltip */}
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              onClick={handleClick}
              className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white font-medium rounded-full transition-all duration-200 shadow-lg shadow-purple-500/25 hover:shadow-purple-500/40"
              data-testid="multi-llm-chatbot-btn"
            >
              <MessageSquare className="w-4 h-4" />
              <span>Multi-LLM ChatBot</span>
              <Info className="w-4 h-4" />
            </button>
          </TooltipTrigger>
          <TooltipContent side="bottom" className="max-w-xs bg-gray-900 text-white p-3 rounded-lg shadow-lg border border-white/10">
            <div className="space-y-2">
              <p className="font-semibold text-sm">💬 Multi-LLM ChatBot</p>
              <p className="text-xs text-gray-300">
                Queries 6 AI models in parallel and selects the best answer:
              </p>
              <ul className="text-xs text-gray-300 list-disc list-inside space-y-1">
                <li><span className="text-emerald-400">OpenAI</span> GPT-4o</li>
                <li><span className="text-orange-400">Claude</span> Sonnet 4.5</li>
                <li><span className="text-blue-400">Grok</span> 4</li>
                <li><span className="text-purple-400">DeepSeek</span> Chat</li>
                <li><span className="text-cyan-400">Gemini</span> 2.0 Flash</li>
                <li><span className="text-teal-400">Perplexity</span> Sonar Pro</li>
              </ul>
              {!isAuthenticated && (
                <p className="text-xs text-yellow-400">⚠️ Login required (Admin only)</p>
              )}
              {isAuthenticated && !isAdmin && (
                <p className="text-xs text-yellow-400">⚠️ Admin access required</p>
              )}
            </div>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>

      {/* Chat Modal */}
      <ChatModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default MultiLLMChatbot;
